import { defineStyle, defineStyleConfig } from "@chakra-ui/react";


const baseStyle = defineStyle({
  color:"#389dc1",
  _hover:{
    color:"#23527c",
  }
});

const linkTheme = defineStyleConfig({
  baseStyle,
});

export default linkTheme;